// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "./application"

import Stations__Show__EquipmentController from "./stations/show/equipment_controller.js"
application.register("stations--show--equipment", Stations__Show__EquipmentController)

import Stations__ShowController from "./stations/show_controller.js"
application.register("stations--show", Stations__ShowController)

import ChannelData__DisplayTariffsController from "./channel_data/display_tariffs_controller.js"
application.register("channel-data--display-tariffs", ChannelData__DisplayTariffsController)

import Reports__ExplorerCompanyController from "./reports/explorer_company_controller.js"
application.register("reports--explorer-company", Reports__ExplorerCompanyController)

import Stations__CharacteristicController from "./stations/characteristic_controller.js"
application.register("stations--characteristic", Stations__CharacteristicController)
